export default __webpack_public_path__ + "static/media/services_makeup.ded8ad1b.jpg";